/**
 * Selector to get an application's flags based on the id, which can be sent in
 */
import { isEqual } from 'es-toolkit';
import { createSelectorCreator, lruMemoize } from 'reselect';

import type { ApplicationFlagEntry } from '/business/shared/state/reducers/applicationFlags';
import getApplicationIdSelector from '/business/shared/state/selectors/application/getApplicationIdSelector';
import getAllApplicationFlagsSelector from './getAllApplicationFlagsSelector';

const createDeepEqualSelector = createSelectorCreator(lruMemoize, isEqual);

const EMPTY_OBJECT: Partial<ApplicationFlagEntry> = {};

export default createDeepEqualSelector(
  [getAllApplicationFlagsSelector, getApplicationIdSelector],
  (allApplicationFlags, applicationId = null) => {
    return allApplicationFlags?.find((application) => application.applicationId === applicationId) || EMPTY_OBJECT;
  },
);
